import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";
import { useLocation } from '@reach/router';

const addVideoTranslation = (postData) => {
  return http().post(endpoints.forms.videoTranslation, postData);
};

export function useVideoTranslation() {
  return useMutation(addVideoTranslation, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
